/*!
 *
 *  hash-page.js
 *
 */

var _hash = location.hash;

var _span = 0;
var setSpan = function(){
	_span = 100;
	if( origin.VPisMobile ){
		_span = 60;
	};
};

module.exports = function(){
	if( _hash ){
		_hash = _hash.replace(/(.*)_/, '$1');
		if( $(_hash).length ){
			origin.$window.on('load', function(){
				setSpan();
				var _top = $(_hash).offset().top;
				$(origin.st).animate({
					scrollTop: _top - _span
				}, 5);
				history.replaceState(null, null, _hash);
				origin.$window.off('.hashScroll');
			});

			origin.$window.on('changeViewportMode.hashScroll', function(){
				setSpan();
			});
		}else{
			history.replaceState(null, null, _hash);
		};
	};
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/hash-page.js
// module id = 12
// module chunks = 0